import { Button, reactIcons as Icon } from '@project44/manifest-ds';

import { scopedT } from '../../../../utils/helpers/scopedT';

const t = scopedT();
interface SeeAllButtonProps {
  onClick?: () => void;
  disabled?: boolean;
}

const SeeAllButton = ({ onClick, disabled }: SeeAllButtonProps) => {
  return (
    <Button
      variant="secondary"
      size="small"
      data-testid="see-all-button"
      onClick={onClick}
      endIcon={<Icon.ChevronRight size="small" />}
      isDisabled={disabled}
    >
      {t('seeAll')}
    </Button>
  );
};

export default SeeAllButton;
